/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';

import classnames from 'classnames/bind';

import { AdminSingleChapterData, AdminSingleChapterMeta } from '@INTERFACES/admin-api/chapters';

import useDocumentPermissions from '@HOOKS/useDocumentPermissions';
import useChapterNameModal from '@HOOKS/store/modals/useChapterNameModal';
import useDeleteChapterModal from '@HOOKS/store/modals/useDeleteChapterModal';

import BasicButton from '@COMPONENTS/COMMON/buttons/BasicButton';
import { useNavigate } from 'react-router-dom';
import styles from './ChapterName.module.scss';

const cx: CX = classnames.bind(styles);

function ChapterName({
    chapterData, chapterMeta, actionButton, bodyContent, isNoIntroduction = false,
    setNoIntroduction = undefined,
}: Props) {
    const navigate = useNavigate();

    const {
        canEditDocument,
    } = useDocumentPermissions({
        documentOwnerId: chapterData.document.owner,
        permissions: chapterMeta.permissions,
    });

    const {
        actions: chapterNameActions,
    } = useChapterNameModal(() => true);

    const {
        actions: deleteChapterActions,
    } = useDeleteChapterModal(() => true);

    const handleDeleteChapter = () => {
        deleteChapterActions.open(
            {
                id: chapterData.id,
                name: chapterData.name,
                documentId: chapterData.document.id,
            },
        );
    };

    return (
        <div className={cx('chapter-name', 'container')}>
            <div className={cx('content-wrapper')}>
                <div className={cx('title-section')}>
                    <div className={cx('name')}>
                        {`Chapter - ${chapterData.name}`}
                    </div>
                    <div className={cx('title-actions')}>
                        <BasicButton
                            title="Delete"
                            variant="danger"
                            size="small"
                            icon="trash"
                            onClick={handleDeleteChapter}
                            tooltip="Delete chapter"
                        />
                        {canEditDocument && (
                            <BasicButton
                                title="Rename"
                                variant="neutral"
                                size="small"
                                icon="edit"
                                onClick={() => {
                                    chapterNameActions.open({
                                        chapterData,
                                    });
                                }}
                                tooltip="Edit chapter name"
                            />
                        )}
                    </div>
                </div>
                <div className={cx('action-button-wrapper')}>
                    {actionButton}
                </div>
            </div>
            {bodyContent && (
                <div className={cx('body-wrapper')}>
                    {bodyContent}
                </div>
            )}
        </div>
    );
}

ChapterName.defaultProps = {
    actionButton: null,
    bodyContent: null,
};

type Props = {
    chapterData: AdminSingleChapterData,
    chapterMeta: AdminSingleChapterMeta,
    actionButton?: React.ReactNode,
    bodyContent?: React.ReactNode,
    isNoIntroduction?: boolean,
    setNoIntroduction?: (value: boolean) => void,
};

export default ChapterName;
